import { render, staticRenderFns } from "./EmailConfiguration.vue?vue&type=template&id=8d23f0cc&"
import script from "./EmailConfiguration.vue?vue&type=script&lang=ts&"
export * from "./EmailConfiguration.vue?vue&type=script&lang=ts&"
import style0 from "./EmailConfiguration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VProgressCircular,VSelect,VSimpleTable,VSkeletonLoader,VTextField})
